import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {EventsComponent} from './events.component';
import {DefaultComponent} from './events-templates/default/default.component';
import {EmotionCupComponent} from './events-templates/emotion-cup/emotion-cup.component';
import {HonorComponent} from './events-templates/honor/honor.component';
import {EventTournamentsComponent} from './event-tournaments/event-tournaments.component';
import {PipeSahredModule} from '../Pipes/pipe-shared.module';
import {MomentModule} from 'angular2-moment';
import {LoadingIndicatorModule} from '../loading-indicator/loading-indicator.module';
import {MatRadioModule} from '@angular/material/radio';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatMenuModule} from '@angular/material/menu';
import {MatDialogModule} from '@angular/material/dialog';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {RouterModule} from '@angular/router';
import {EventsService} from './events.service';
import {GlobalService} from '../global.service';
import {FacebookModule} from 'ngx-facebook';
import {InsomniaEgyptComponent} from './events-templates/insomnia-egypt/insomnia-egypt.component';
import {CounterStrikeComponent} from './events-templates/insomnia-egypt/counter-strike/counter-strike.component';
import {LeagueOfLegendsComponent} from './events-templates/insomnia-egypt/league-of-legends/league-of-legends.component';
import {RainbowSixComponent} from './events-templates/insomnia-egypt/rainbow-six/rainbow-six.component';
import {TekkenComponent} from './events-templates/insomnia-egypt/tekken/tekken.component';
import {OverwatchComponent} from './events-templates/insomnia-egypt/overwatch/overwatch.component';
import {DotaComponent} from './events-templates/insomnia-egypt/dota/dota.component';
import {HomeComponent} from './events-templates/insomnia-egypt/home/home.component';
import {FortniteComponent} from './events-templates/insomnia-egypt/fortnite/fortnite.component';
import {CallOfDutyComponent} from './events-templates/insomnia-egypt/call-of-duty/call-of-duty.component';
import {
  InsominaTermsConditionsComponent
} from './events-templates/insomnia-egypt/insomina-terms-conditions/insomina-terms-conditions.component';
import {HuaweiEgyptComponent} from './events-templates/huawei-egypt/huawei-egypt.component';
import {FifaComponent} from './events-templates/insomnia-egypt/fifa/fifa.component';
import {BlackoutBattleRtxComponent} from './events-templates/blackout-battle-rtx/blackout-battle-rtx.component';
import {CfcComponent} from './events-templates/cfc/cfc.component';
import {CfcStatsComponent} from './events-templates/cfc/cfc-stats/cfc-stats.component';
import {CommunityComponent} from './events-templates/community/community.component';
import {PortoComponent} from './events-templates/porto/porto.component';
import {PaginationModule} from 'ngx-bootstrap/pagination';
import {LeaderboardsComponent} from './events-templates/porto/leaderboards/leaderboards.component';
import {InsomniaEgypt19Component} from './events-templates/insomnia-egypt19/insomnia-egypt19.component';
import {halloweenNights} from './events-templates/halloween-nights/halloween-nights.component';
import {HalloweenTournamentsComponent} from './events-templates/halloween-nights/halloween-tournaments/halloween-tournaments.component';
import {InsomniaTournamentsComponent} from './events-templates/insomnia-egypt19/insomnia-tournaments/insomnia-tournaments.component';
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {PERFECT_SCROLLBAR_CONFIG} from 'ngx-perfect-scrollbar';
import {PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';
import {WinterWonderComponent} from './events-templates/winter-wonder/winter-wonder.component';
import {
  WinterWonderTournamentsComponent
} from './events-templates/winter-wonder/winter-wonder-tournaments/winter-wonder-tournaments.component';
import {ChristmasTournamentsComponent} from './events-templates/christmas/christmas-tournaments/christmas-tournaments.component';
import {ShawarmerComponent} from './events-templates/shawarmer/shawarmer.component';
import {ShawarmerTournmanetsComponent} from './events-templates/shawarmer/shawarmer-tournmanets/shawarmer-tournmanets.component';
import {FriendZoneComponent} from './events-templates/friend-zone/friend-zone.component';
import {FriendZoneTournamentsComponent} from './events-templates/friend-zone/friend-zone-tournaments/friend-zone-tournaments.component';
import {PubgLiteComponent} from './events-templates/spring-break/pubg-lite/pubg-lite.component';
import {CrossfireComponent} from './events-templates/spring-break/crossfire/crossfire.component';
import {SpringBreakComponent} from './events-templates/spring-break/spring-break.component';
import {RainbowSixSeigeComponent} from './events-templates/spring-break/rainbow-six-siege/rainbow-six-siege.component';
import {TournamentTemplateComponent} from './events-templates/spring-break/tournament-template/tournament-template.component';
import {SpringHomeComponent} from './events-templates/spring-break/spring-home/spring-home.component';
import {PubgComponent} from './events-templates/spring-break/pubg/pubg.component';
import {Covid19AdviceComponent} from './events-templates/spring-break/covid19-advice/covid19-advice.component';
import {FooterComponent} from './events-templates/spring-break/footer/footer.component';
import {Ramadan2020Component} from './events-templates/ramadan2020/ramadan2020.component';
import {RamadanHomeComponent} from './events-templates/ramadan2020/ramadan-home/ramadan-home.component';
import {Ramadan20TournamentsComponent} from './events-templates/ramadan2020/ramadan20-tournaments/ramadan20-tournaments.component';
import {Ramadan20PubgLiteComponent} from './events-templates/ramadan2020/ramadan20-pubg-lite/ramadan20-pubg-lite.component';
import {Ramadan20BrawlStarsComponent} from './events-templates/ramadan2020/ramadan20-brawl-stars/ramadan20-brawl-stars.component';
import {Ramadan20FooterComponent} from './events-templates/ramadan2020/ramadan20-footer/ramadan20-footer.component';
import {Ramadan20CrossfireComponent} from './events-templates/ramadan2020/ramadan20-crossfire/ramadan20-crossfire.component';
import {Ramadan20FortniteComponent} from './events-templates/ramadan2020/ramadan20-fortnite/ramadan20-fortnite.component';
import {Ramadan20ClashRoyaleComponent} from './events-templates/ramadan2020/ramadan20-clash-royale/ramadan20-clash-royale.component';
import {Ramadan20PubgComponent} from './events-templates/ramadan2020/ramadan20-pubg/ramadan20-pubg.component';
import {
  Ramadan20RainbowSixSiegeComponent
} from './events-templates/ramadan2020/ramadan20-rainbow-six-siege/ramadan20-rainbow-six-siege.component';
import {
  Ramadan20LeagueOfLegendsComponent
} from './events-templates/ramadan2020/ramadan20-league-of-legends/ramadan20-league-of-legends.component';
import {RamadanCovid19AdviceComponent} from './events-templates/ramadan2020/ramadan-covid19-advice/ramadan-covid19-advice.component';
import {OrangeRamadanCupComponent} from './events-templates/orange-ramadan-cup/orange-ramadan-cup.component';
import {
  OrangeRamadanTournamentsComponent
} from './events-templates/orange-ramadan-cup/orange-ramadan-tournaments/orange-ramadan-tournaments.component';
import {OrangeRamadanFooterComponent} from './events-templates/orange-ramadan-cup/orange-ramadan-footer/orange-ramadan-footer.component';
import {YallaAwcComponent} from './events-templates/yalla-awc/yalla-awc.component';
import {YallaAwcTournamentsComponent} from './events-templates/yalla-awc/yalla-awc-tournaments/yalla-awc-tournaments.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {SnickersECupComponent} from './events-templates/snickers-e-cup/snickers-e-cup.component';
import {GeneralInfoComponent} from './events-templates/snickers-e-cup/general-info/general-info.component';
import {TournamentRulesComponent} from './events-templates/snickers-e-cup/tournament-rules/tournament-rules.component';
import {BracketsComponent} from './events-templates/snickers-e-cup/brackets/brackets.component';
import {ParticipantsComponent} from './events-templates/snickers-e-cup/participants/participants.component';
import {HowToJoinComponent} from './events-templates/snickers-e-cup/how-to-join/how-to-join.component';
import {SvgIconsModule} from '../../../projects/svg-icons/src/lib/svg-icons.module';
import {
  svgIconsGlobe,
  svgIconsArena,
  svgIconsBug,
  svgIconsCalendar,
  svgIconsCancel,
  svgIconsChatBar,
  svgIconsCog,
  svgIconsCupBar,
  svgIconsDone,
  svgIconsDown,
  svgIconsEdit,
  svgIconsEmail,
  svgIconsEye,
  svgIconsGameBar,
  svgIconsGameFire,
  svgIconsGameLg,
  svgIconsGameMd,
  svgIconsGroup,
  svgIconsHomeBar,
  svgIconsInfo,
  svgIconsLang,
  svgIconsLogin,
  svgIconsLogout,
  svgIconsFriendList,
  svgIconsMedal,
  svgIconsNotification,
  svgIconsPassword,
  svgIconsPlus,
  svgIconsRight,
  svgIconsSearch,
  svgIconsSignUp,
  svgIconsTeam,
  svgIconsWinner,
  svgIconsWatch,
  svgIconsWorld,
  svgIconsTrophy2,
  svgIconsTrophy3,
  svgIconsSetting,
  svgIconsLangs,
  svgIconsAlert,
  svgIconsTimeline,
  svgIconsShare,
  svgIconsTwitter,
  svgIconsGoogle,
  svgIconsFaceBook,
  svgIconsFacebookGrey,
  svgIconsGoogleGrey,
  svgIconsMultiGroup,
  svgIconsCamera,
  svgIconsCapitain,
  svgIconsEditPinWhite,
  svgIconsArrowBottom,
  svgIconsMenubar,
  svgIconsVerified,
  svgIconsHeart,
  svgIconsCommunityPartner,
  svgIconsPhone,
  svgIconsInstagram,
  svgIconsYoutube,
  svgIconsTwitterGray,
  svgIconsDiscord,
  svgDiscordGrey,
  svgIconsSupport,
  svgIconsPrize,
  svgIconsMoney,
  svgIconFinished,
  svgIconMissedTournament,
  svgIconsTournamentStarted,
  svgIconsCheckedIn,
  svgIconsremoveCheckedIn,
  svgIconsTrouphy
} from '../../../projects/svg-icons/src/lib/svg-icons';
import {SvgIconsRegistery} from '../../../projects/svg-icons/src/lib/svg-icons.registery';
import {RenoCupComponent} from './events-templates/reno-cup/reno-cup.component';
import {RenoCupTournamentsComponent} from './events-templates/reno-cup/reno-cup-tournaments/reno-cup-tournaments.component';
import {RenoCupQualifiedComponent} from './events-templates/reno-cup/reno-cup-qualified/reno-cup-qualified.component';
import {RenoCupBracketsComponent} from './events-templates/reno-cup/reno-cup-brackets/reno-cup-brackets.component';
import {HighlightsComponent} from './events-templates/reno-cup/highlights/highlights.component';
import {RulesComponent} from './events-templates/reno-cup/rules/rules.component';
import {OppoEgypt2021Component} from './events-templates/oppo-egypt2021/oppo-egypt2021.component';
import {OppoEgyptTournamentsComponent} from './events-templates/oppo-egypt2021/oppo-egypt-tournaments/oppo-egypt-tournaments.component';
import {PrizesComponent} from './events-templates/oppo-egypt2021/prizes/prizes.component';
import {PlayerCardComponent} from './events-templates/oppo-egypt2021/player-card/player-card.component';
import {RulesTermsComponent} from './events-templates/oppo-egypt2021/rules-terms/rules-terms.component';
import {OppoEgyptFooterComponent} from './events-templates/oppo-egypt2021/oppo-egypt-footer/oppo-egypt-footer.component';
import {OppoGulf2021Component} from './events-templates/oppo-gulf2021/oppo-gulf2021.component';
import {OppoGulfTournamentsComponent} from './events-templates/oppo-gulf2021/oppo-gulf-tournaments/oppo-gulf-tournaments.component';
import {OppoGulfFooterComponent} from './events-templates/oppo-gulf2021/oppo-gulf-footer/oppo-gulf-footer.component';
import {QualifiedPlayerComponent} from './events-templates/oppo-gulf2021/qualified-player/qualified-player.component';
import {PrizesGulfComponent} from './events-templates/oppo-gulf2021/prizes-gulf/prizes-gulf.component';
import {RulesTermsGulfComponent} from './events-templates/oppo-gulf2021/rules-terms-gulf/rules-terms-gulf.component';
import {TecnoCupComponent} from './events-templates/tecno-cup/tecno-cup.component';
import {TecnoTournamentsComponent} from './events-templates/tecno-cup/tecno-tournaments/tecno-tournaments.component';
import {TecnoPlayerCardComponent} from './events-templates/tecno-cup/player-card/player-card.component';
import {Ramdan2022Component} from './events-templates/ramdan2022/ramdan2022.component';
import {Ramadan2022HeaderComponent} from './events-templates/ramdan2022/ramadan2022-header/ramadan2022-header.component';
import {Ramadan2022FooterComponent} from './events-templates/ramdan2022/ramadan2022-footer/ramadan2022-footer.component';
import {Ramadan2022HomePageComponent} from './events-templates/ramdan2022/ramadan2022-home-page/ramadan2022-home-page.component';
import {Ramadan2022TournamentComponent} from './events-templates/ramdan2022/ramadan2022-tournament/ramadan2022-tournament.component';
import {
  Ramadan2022PlayerQualifiedComponent
} from './events-templates/ramdan2022/ramadan2022-player-qualified/ramadan2022-player-qualified.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import {TournamentsReusableComponent} from './events-templates/resusable-component/tournaments-reusable/tournaments-reusable.component';
import {TecnoTournamentsIraqcomponent} from './events-templates/tecno-cup-iraq/tecno-tournaments/tecno-tournaments.iraqcomponent';
import {TecnoCupIraqComponent} from './events-templates/tecno-cup-iraq/tecno-cup-iraq.component';
import {TecnoPlayerCardIraqComponent} from './events-templates/tecno-cup-iraq/player-card/player-card-iraq.component';
import {RulesTermsTecnoIraqComponent} from './events-templates/tecno-cup-iraq/rules-terms/rules-terms-tecno-iraq.component';
import {MainPageIraqComponent} from './events-templates/tecno-cup-iraq/main-page/main-page-iraq.component';
import {FooterReusableComponent} from './events-templates/resusable-component/footer-reusable/footer-reusable.component';
import {PlayerCardResuableComponent} from './events-templates/resusable-component/player-card-resuable/player-card-resuable.component';
import {TecnoCupKsaComponent} from './events-templates/tecno-cup-ksa/tecno-cup-ksa.component';
import {HomePageKSAComponent} from './events-templates/tecno-cup-ksa/Home-page/Home-page-KSA.component';
import {TecnoTournamentsKSAComponent} from './events-templates/tecno-cup-ksa/tecno-tournaments/tecno-tournaments.KSA.component';
import { RulesTermsTecnoKSAComponent} from './events-templates/tecno-cup-ksa/rules-terms/rules-terms-tecno-KSA.component';
import { TecnoPlayerCardKSAComponent} from './events-templates/tecno-cup-ksa/player-card/player-card-KSA.component';
import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  // suppressScrollX: true
};

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    PaginationModule.forRoot(),
    RouterModule,
    FacebookModule.forRoot(),
    CommonModule,
    PipeSahredModule,
    PerfectScrollbarModule,
    MomentModule,
    LoadingIndicatorModule,
    MatCheckboxModule,
    SvgIconsModule,
    MatTabsModule,
    MatMenuModule,
    MatTooltipModule,
    MatRadioModule,
    MatDialogModule,
    TooltipModule, MatExpansionModule, MatSidenavModule, MatIconModule, MatToolbarModule
  ],
  declarations: [EventTournamentsComponent, TecnoCupKsaComponent, TecnoTournamentsKSAComponent, RulesTermsTecnoKSAComponent,
    TecnoPlayerCardKSAComponent, HomePageKSAComponent, HonorComponent, TecnoTournamentsIraqcomponent, TecnoCupIraqComponent, MainPageIraqComponent,
    TecnoPlayerCardIraqComponent, RulesTermsTecnoIraqComponent, EventsComponent, DefaultComponent, EmotionCupComponent, TecnoPlayerCardComponent,
    InsomniaEgyptComponent, CounterStrikeComponent, LeagueOfLegendsComponent, RainbowSixComponent,
    TekkenComponent, OverwatchComponent, DotaComponent, HomeComponent, FortniteComponent, CallOfDutyComponent,
    InsominaTermsConditionsComponent, HuaweiEgyptComponent, FifaComponent, BlackoutBattleRtxComponent, CfcComponent,
    CfcStatsComponent, CommunityComponent, PortoComponent, LeaderboardsComponent, InsomniaEgypt19Component,
    halloweenNights, HalloweenTournamentsComponent, InsomniaTournamentsComponent, WinterWonderComponent,
    WinterWonderTournamentsComponent, ChristmasTournamentsComponent, ShawarmerComponent,
    ShawarmerTournmanetsComponent, FriendZoneComponent, FriendZoneTournamentsComponent,
    PubgLiteComponent, CrossfireComponent, SpringBreakComponent, RainbowSixSeigeComponent,
    TournamentTemplateComponent, SpringHomeComponent, PubgComponent, Covid19AdviceComponent,
    FooterComponent, Ramadan2020Component, RamadanHomeComponent, Ramadan20TournamentsComponent,
    Ramadan20PubgLiteComponent, Ramadan20BrawlStarsComponent, Ramadan20FooterComponent,
    Ramadan20CrossfireComponent, Ramadan20FortniteComponent, Ramadan20ClashRoyaleComponent,
    Ramadan20PubgComponent, Ramadan20RainbowSixSiegeComponent, Ramadan20LeagueOfLegendsComponent,
    RamadanCovid19AdviceComponent, OrangeRamadanCupComponent, OrangeRamadanTournamentsComponent,
    OrangeRamadanFooterComponent, YallaAwcComponent, YallaAwcTournamentsComponent, SnickersECupComponent, GeneralInfoComponent,
    TournamentRulesComponent, BracketsComponent, ParticipantsComponent, HowToJoinComponent, RenoCupComponent, RenoCupTournamentsComponent,
    RenoCupQualifiedComponent, RenoCupBracketsComponent, HighlightsComponent, RulesComponent, OppoEgypt2021Component, OppoEgyptTournamentsComponent,
    PrizesComponent, PlayerCardComponent, RulesTermsComponent, OppoEgyptFooterComponent, OppoGulf2021Component, OppoGulfTournamentsComponent,
    OppoGulfFooterComponent, QualifiedPlayerComponent, PrizesGulfComponent, RulesTermsGulfComponent, TecnoCupComponent, TecnoTournamentsComponent, Ramdan2022Component, Ramadan2022HeaderComponent, Ramadan2022FooterComponent, Ramadan2022HomePageComponent, Ramadan2022TournamentComponent, Ramadan2022PlayerQualifiedComponent, TournamentsReusableComponent, FooterReusableComponent, PlayerCardResuableComponent],
  providers: [EventsService, GlobalService, DatePipe,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }],
  exports: [
    FooterReusableComponent,
    TournamentsReusableComponent
  ]
})
export class EventsModule {
  constructor(private svgIconRegistery: SvgIconsRegistery) {
    this.svgIconRegistery.registerIcons([
      svgIconsArena,
      svgIconsBug,
      svgIconsCalendar,
      svgIconsCancel,
      svgIconsChatBar,
      svgIconsCog,
      svgIconsCupBar,
      svgIconsDone,
      svgIconsDown,
      svgIconsEdit,
      svgIconsEmail,
      svgIconsEye,
      svgIconsGameBar,
      svgIconsGameFire,
      svgIconsGameLg,
      svgIconsGameMd,
      svgIconsGroup,
      svgIconsHomeBar,
      svgIconsInfo,
      svgIconsLang,
      svgIconsLogin,
      svgIconsLogout,
      svgIconsFriendList,
      svgIconsMedal,
      svgIconsNotification,
      svgIconsPassword,
      svgIconsPlus,
      svgIconsRight,
      svgIconsSearch,
      svgIconsSignUp,
      svgIconsTeam,
      svgIconsWinner,
      svgIconsWatch,
      svgIconsWorld,
      svgIconsTrophy2,
      svgIconsTrophy3,
      svgIconsSetting,
      svgIconsLangs,
      svgIconsAlert,
      svgIconsTimeline,
      svgIconsShare,
      svgIconsTwitter,
      svgIconsGoogle,
      svgIconsFaceBook,
      svgIconsFacebookGrey,
      svgIconsGoogleGrey,
      svgIconsMultiGroup,
      svgIconsCamera,
      svgIconsCapitain,
      svgIconsEditPinWhite,
      svgIconsArrowBottom,
      svgIconsMenubar,
      svgIconsVerified,
      svgIconsHeart,
      svgIconsCommunityPartner,
      svgIconsGlobe,
      svgIconsPhone,
      svgIconsInstagram,
      svgIconsYoutube,
      svgIconsTwitterGray,
      svgIconsDiscord,
      svgDiscordGrey,
      svgIconsSupport,
      svgIconsPrize,
      svgIconsMoney,
      svgIconFinished,
      svgIconMissedTournament,
      svgIconsTournamentStarted,
      svgIconsCheckedIn,
      svgIconsremoveCheckedIn,
      svgIconsTrouphy
    ]);
  }
}
